import axios from 'axios'
import getHeaders from '../helpers/headers'
import config from '../../constants/endpoints.js'
import { getError } from 'api/helpers'

const { folders } = config.endpoints

const getFolders = data => axios({
  method: 'POST',
  url: folders.list,
  data,
  headers: getHeaders(true)
})

const createFolder = data => axios({
  method: 'POST',
  url: folders.create,
  data,
  headers: getHeaders(true)
}).catch(error => {
  throw getError(error)
})

const updateFolder = ({ folderId, data }) => axios({
  method: 'PUT',
  url: folders.byId.replace(':folderId', folderId),
  data,
  headers: getHeaders(true)
})

const deleteFolder = data => axios({
  method: 'POST',
  url: folders.delete,
  data,
  headers: getHeaders(true)
})

export default {
  getFolders,
  createFolder,
  updateFolder,
  deleteFolder
}
